import { getFunctions, httpsCallable } from 'firebase/functions';
import app from '../config/firebase';

// Initialize Cloud Functions
const functions = getFunctions(app, 'us-central1');

// ==================== DESIGNS API (WRITE ONLY - Callable Functions) ====================

export const designsAPI = {
  generate: async (prompt, projectId, aspectRatio) => {
    const generateDesign = httpsCallable(functions, 'generateDesign');
    return generateDesign({ prompt, projectId, aspectRatio });
  },
  regenerate: async (prompt, projectId, aspectRatio) => {
    const regenerateDesign = httpsCallable(functions, 'regenerateDesign');
    return regenerateDesign({ prompt, projectId, aspectRatio });
  },
};

// ==================== PROJECTS API (WRITE ONLY - Callable Functions) ====================

export const projectsAPI = {
  update: async (projectId, data) => {
    const updateProject = httpsCallable(functions, 'updateProject');
    return updateProject({ projectId, ...data });
  },
  delete: async (projectId) => {
    const deleteProject = httpsCallable(functions, 'deleteProject');
    return deleteProject({ projectId });
  },
};

// ==================== SUBSCRIPTIONS API (WRITE ONLY - Callable Functions) ====================

export const subscriptionsAPI = {
  subscribe: async (planId) => {
    const subscribeToPlan = httpsCallable(functions, 'subscribeToPlan');
    return subscribeToPlan({ planId });
  },
  cancel: async () => {
    const cancelSubscription = httpsCallable(functions, 'cancelSubscription');
    return cancelSubscription();
  },
};

// ==================== ADMIN API (WRITE ONLY - Callable Functions) ====================

export const adminAPI = {
  adjustCredits: async (userId, amount, description) => {
    const adjustUserCredits = httpsCallable(functions, 'adjustUserCredits');
    return adjustUserCredits({ userId, amount, description });
  },
  updateRole: async (userId, role) => {
    const updateUserRole = httpsCallable(functions, 'updateUserRole');
    return updateUserRole({ userId, role });
  },
  deactivateUser: async (userId) => {
    const deactivateUser = httpsCallable(functions, 'deactivateUser');
    return deactivateUser({ userId });
  },
};

export default functions;